// extracted by mini-css-extract-plugin
export default {"tab":"mnvHNmL7eiVgkMPpibaC","active":"uKKbRmG5gLjEzAPvJvyZ","icon":"ihNTSw2S3qPZ4erjjyjm"};